import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TableData from '../../custom/Table/TableData';
import CellType from '../../../constants/type';
import useI18n from '../../../hooks/useI18n';
import useUserInfo from '../../../hooks/useUserInfo';
import { basketState } from '../../../state/basketState';
import { useRecoilState } from "recoil";
import { Alert, Divider, TextField, Tooltip } from '@mui/material';
import ScaleIcon from '@mui/icons-material/Scale';
import WbIridescentIcon from '@mui/icons-material/WbIridescent';
import basketService from '../../../api/basket';
import ConfirmDialog from '../../custom/ConfirmDialog/ConfirmDialog';
import InfoDialog from '../../custom/InfoDialog/InfoDialog';
import DetailScreen from '../../custom/DetailScreen/DetailScreen';
import moment from 'moment';
import { isCheckQuant, orderlimit, currencySignPrice1, compDetailUrl, appCompno } from '../../../config';
import { Await } from 'react-router-dom';

function BasketPage() {

    const { lang, l } = useI18n();
    //const [basket, setBasket] = React.useState([]);
    const [basketRecoil, setBasketRecoil] = useRecoilState(basketState);
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
    const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
    const [openSuccessDialog, setOpenSuccessDialog] = React.useState(false);
    const [rate, setRate] = React.useState(0);
    const { user } = useUserInfo();
    const [comment, setComment] = React.useState('');
    const [titelInfoDialog, setTitelInfoDialog] = React.useState(null);
    const [contentTextInfoDialog, setContentTextInfoDialog] = React.useState(null);
    
    const [openDetail, setOpenDetail] = React.useState(false);
    const [detailUrl, setDetailUrl] = React.useState('');

    const GetBasket = async () => {
        try {
            const basket = await basketService.findAllByUserId(user.code, lang);

            // console.log('basket :>> ', basket);

            setRate(basket?.math[0]?.frate);
            setOpenAlertDialog(!basket?.math?.find((item) => item.quant < item.fminqty))
            setBasketRecoil({ basket });
        } catch (error) {
            console.error('Error findAllByUserId >> ', error);

        }
    };

    React.useEffect(() => {
        setBasketRecoil({ basket: {} });
        if (user) GetBasket();
    }, [user]);

    const handleDelete = () => {

        const fetcData = async () => {

            try {
                await basketService.deleteBasket();
                clearBasket();
            } catch (error) {
                console.error('Error deleteBasket >> ', error);
            }
        };

        fetcData();

        setOpenConfirmDialog(false)
    };

    const handleConfirm = () => {

        const fetcData = async () => {

            try {
                const data = { ...basketRecoil.basket, comment };
                const res = await basketService.confirmBasket(data);

                // if (res?.itemOutStock) {

                //     var newMath = [];

                //     // Перевірка наявності товару в кошику
                //     for (let i = 0; i < data.math.length; i++) {
                //         let element = data.math[i];
                //         newMath.push({...element});
                //         const itemStock = res?.basketWithStock.find(item => item.qtartcode === element.qtartcode);
                //         const accessItemQty = (itemStock.instocksum || 0) - (itemStock.reservedsum || 0) - (itemStock.reservedforim || 0);

                //         if (accessItemQty < element.quant) {
                //             newMath[i].redBorder = true;
                //             newMath[i].inStock = accessItemQty;
                //         }
                //     }  

                //     const newData = {basket: {
                //         math: [],
                //         totsum: basketRecoil.basket.totsum,
                //         totvolume: basketRecoil.basket.totvolume,
                //         totweight: basketRecoil.basket.totweight
                //     }};
                //     newData.basket.math = newMath.sort((a, b) => a.inStock - b.inStock);
                //     setBasketRecoil(newData)

                //     setTitelInfoDialog('');
                //     setContentTextInfoDialog(`${l('The quantity of the product is not enough in stock')}.`);
                //     setOpenSuccessDialog(true);
                //     return;
                // }
                // else{
                //     setTitelInfoDialog(null);
                //     setContentTextInfoDialog(null)
                // }

                if(res.isSync) {
                    setOpenSuccessDialog(true);
                    clearBasket();
                }
                else{
                    const currentTime = moment();
                    const timeToMoment = moment('00:00', 'HH:mm');
                    const timeFromMoment = moment('07:00', 'HH:mm');

                    // Перевірка, чи поточний час знаходиться в заданому проміжку
                    if (currentTime.isBetween(timeToMoment, timeFromMoment, undefined, '[]')) { 
                        setTitelInfoDialog(''+l('Server error'));
                        setContentTextInfoDialog(l('The server is not working at this time, try sending the order after 07:00.'));
                    }
                    else{
                        setTitelInfoDialog(l('Server error'));
                        setContentTextInfoDialog(l('An error occurred while confirming the order.'));
                    }
                    setOpenSuccessDialog(true);
                }
               
            } catch (error) {
                console.error('Error deleteBasket >> ', error);
            }
        };

        fetcData();
    };

    const clearBasket = () => {
        const newBasket = {
            basket: {},
        };
        setBasketRecoil(newBasket);
    };

    const columns = [
        { id: 'qtartcode', label: l('Code'), minWidth: 150, type: CellType.STRING },
        { id: 'fname', label: l('Name'), minWidth: 200, type: CellType.PRODUCT_NAME },
        { id: 'fimg', label: l('Image'), minWidth: 80, type: CellType.IMG, align: 'center' },
        { id: 'fprice1', label: `${l('Price')}` + (appCompno === '2' ? `,${currencySignPrice1}` : ''), minWidth: 100, type: CellType.PRISE_WITH_DISCOUNT, align: 'center' },
        { id: 'quant', label: l('Quantity'), minWidth: 80, type: CellType.EDITABLE_NUMBER },
        { id: 'itemsum', label: l('Sum'), minWidth: 80, type: CellType.PRODUCT_SUM },
        { id: 'action', label: l('Action'), minWidth: 80, type: CellType.ACTIONS, align: 'center' },
    ];

    const debounceRefEditableNumbers = React.useRef(null);
    const handelAction = (event, type, row) => {

        const { value } = event.target;

        switch (type) {
            case CellType.EDITABLE_NUMBER:

                if(value === '0' || value === '') {
                    event.target.value = 1;
                    return;

                }

                event.target.value = (value.toString() === '0' || value.toString() === '') ? '0' : value.toString().replace(/^0+/, '')

                if (debounceRefEditableNumbers.current) {
                    clearTimeout(debounceRefEditableNumbers.current);
                }

                debounceRefEditableNumbers.current = setTimeout(() => {
                    const newRow = { ...row };

                    newRow.quant = value;
                    const discount = newRow.fdiscount || 0;

                    let pricewithoutDiscount = Math.round(newRow.price * newRow.quant * 100) / 100;
                    let priceWithDiscount = Math.round((pricewithoutDiscount - (pricewithoutDiscount * discount / 100)) * 100) / 100;
                    newRow.itemsum = priceWithDiscount;

                    // let priceWithDiscount = Math.round((newRow.FPRICE1 - (newRow.FPRICE1 * discount / 100)) * 100) / 100;
                    // priceWithDiscount = Math.round(priceWithDiscount * newRow.QUANT * 100) / 100;
                    // newRow.ITEMSUM = priceWithDiscount;

                    newRow.sumfweight = Math.round(newRow.fweight * newRow.quant * 1000) / 1000;
                    newRow.sumfvolume = Math.round(newRow.fvolume * newRow.quant * 100000) / 100000;



                    if (user) {
                        try {
                            const fetcData = async () => {

                                const newBasket = await basketService.updateBasket(newRow);

                                setOpenAlertDialog(!newBasket?.math?.find((item) => item.quant < item.fminqty))

                                setBasketRecoil({ basket: newBasket || {} });
                            };

                            fetcData();

                        } catch (error) {
                            console.error('Error update Cart :>> ', error);
                        }
                    }

                    event.target.select();
                }, 500); // Затримка у 500 мс

                break;

                case CellType.ACTIONS:
                    const newRow = { ...row };

                    newRow.quant = 0;

                    if (user) {
                        try {
                            const fetcData = async () => {

                                setBasketRecoil({});
                                
                                const newBasket = await basketService.updateBasket(newRow);

                                setOpenAlertDialog(!newBasket?.math?.find((item) => item.quant < item.fminqty))                             
                               
                                setBasketRecoil({ basket: newBasket || {} });
                            };

                            fetcData();

                        } catch (error) {
                            console.error('Error update Cart :>> ', error);
                        }
                    }

                break;

                case CellType.PRODUCT_NAME:
                const url = compDetailUrl + row.FINFOPAGE;

                setOpenDetail(true);
                setDetailUrl(url);
                break;

            default:
                break;
        }

    }

    return (
        <>
            <Box display="flex" flexDirection='column' sx={{ mt: 2 }} gap={2}>
                <Box display="flex" gap={2} justifyContent="space-between">
                    <Box display="flex" alignItems={'center'} gap={2}>
                        <Typography component="h2" variant="h5">
                            {l('Confirm the shipment of the Order')}
                        </Typography>

                        <Divider orientation="vertical" flexItem />

                        <Typography component="h6" variant="h6">
                            {l('Total')}:
                        </Typography>

                        <Typography display="flex" alignItems="center" component="h6" variant="h6">
                            <Box style={{ color: "green", fontSize: '1.25rem' }}>
                                {basketRecoil?.basket?.totsum || 0}{currencySignPrice1}
                            </Box>
                            {/* {appCompno === '1' ? 
                            <Tooltip title={l('Exchange rate') + `: ${rate} ₴`}>
                                <Box style={{ color: "green", marginLeft: '5px' }}>
                                    {`(~${Math.round(rate * basketRecoil?.basket?.totsum) || 0}₴)`}
                                </Box>
                            </Tooltip> : ''} */}
                        </Typography>

                        <Typography display="flex" alignItems="center" component="h6" variant="h6">
                            <ScaleIcon />
                            <span style={{ color: "#dc3545", marginLeft: 5 }}>
                                {basketRecoil?.basket?.totweight}{l('Kg')}
                            </span>
                        </Typography>

                        <Typography display="flex" alignItems="center" component="h6" variant="h6">
                            <WbIridescentIcon />
                            <span style={{ color: "#007bff", marginLeft: 5 }}>
                                {basketRecoil?.basket?.totvolume}{l('m³')}
                            </span>
                        </Typography>
                    </Box>

                    <Box display={'flex'} alignItems={'center'}>
                        <Button disabled={isCheckQuant === '1' ? (basketRecoil?.basket?.totsum < orderlimit || !basketRecoil?.basket?.math?.length || !openAlertDialog) : basketRecoil?.basket?.math?.length ? false : true}
                            sx={{
                                mr: 2,
                                "&.Mui-disabled": {
                                    color: "white",
                                }
                            }}
                            variant="contained"
                            autoFocus
                            color="success"
                            onClick={handleConfirm}
                        >
                            {l('Send')}
                        </Button> 
                        <Button
                            sx={{
                                "&.Mui-disabled": {
                                    color: "white",
                                }
                            }}
                            disabled={!basketRecoil?.basket?.math?.length}
                            variant="contained"
                            autoFocus
                            color="error"
                            onClick={() => setOpenConfirmDialog(true)}>
                            {l('Clear basket')}
                        </Button>
                    </Box>

                </Box>
                <Box>
                    <TableData
                        columns={columns}
                        rows={basketRecoil?.basket?.math || []}
                        cellBtnActionByType={handelAction}
                        rowsPerPageV = {500}
                    />
                    {basketRecoil?.basket?.math?.length === 0 || !basketRecoil?.basket?.math ? <Typography marginTop={2} color='grey' textAlign='center' component="p" variant="h5">{l('Cart is empty')}</Typography> : ''}
                </Box>
                
                {basketRecoil?.basket?.totsum < orderlimit ? <Alert severity="error">{l('The order amount must be at least ') + currencySignPrice1 + orderlimit}</Alert> : ''}
                {isCheckQuant === '1' ? (!openAlertDialog && basketRecoil?.basket?.math?.length) ? <Alert severity="error">{l('The number of selected products is less than the minimum')}</Alert> : '' : ''}

                <Box width='100%'>
                    <TextField
                        fullWidth
                        onChange={(e) => setComment(e.target.value)}
                        sx={{ backgroundColor: 'white' }}
                        multiline
                        rows={1}
                        label={`${l("Your comment")}...`}
                        variant="outlined"
                        inputProps={{ maxLength: 125 }}
                    />
                    <Typography color='#515151' marginTop={1} component="p" variant="p">
                        {l('Number of characters')} {comment.length} {l('of')} 125
                    </Typography>
                </Box>
            </Box>
            <ConfirmDialog
                handleConfirm={handleDelete}
                open={openConfirmDialog}
                handleClose={() => setOpenConfirmDialog(false)}
                title={`⚠️ ${l('Clear basket')}`}
                contentText={`${l('Are you sure that you want to clear the basket, all products that were selected will be deleted')}!`}
                denyButtonText={l('Cancel')}
                confirmButtonText={l('Agree')}
            />
            <InfoDialog
                handleConfirm={() => setOpenSuccessDialog(false)}
                open={openSuccessDialog}
                handleClose={() => setOpenSuccessDialog(false)}
                title={titelInfoDialog ||`${l('Information')}`}
                contentText={contentTextInfoDialog || `${l('Thank you for the order')}! ${l('Our manager will contact you as soon as possible')}.`}
                confirmButtonText={l('OK')}
            />
            <DetailScreen isOpened={openDetail} setOpenDetail={setOpenDetail} detailUrl={detailUrl} />
        </>
    );
}

export default BasketPage;